import React, { useEffect } from "react";
import { useBlocNext } from "@blac/react";
import styled from "@emotion/styled";
import Track from "../Track/Track";
import TaskManagementBloc, {
  TaskKey
} from "src/state/TaskManagementBloc/TaskManagementBloc";
import LabStatusOverviewCubit from "./LabStatusOverviewCubit";
import LabCategoryToggle from "../LabCategoryToggle/LabCategoryToggle";
import Translate from "../Translate/Translate";

const CategoryContainer = styled.div`
  label: LabCategoryContainer;
  display: flex;
  flex-direction: column;
  width: min(100%, 400px);
  background: var(--color-white);
  border-radius: 0.8rem;
  overflow: hidden;
  box-shadow: var(--light-shadow);
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--space-lg);
`;

const ErrorContainer = styled.div`
  padding: var(--space-md);
  text-align: center;
  color: var(--color-error);
`;

const LabStatusOverview: React.FC = () => {
  const [state, { fetchLabStatus, labsTrackingData }] = useBlocNext(
    LabStatusOverviewCubit
  );

  const [, { getTask }] = useBlocNext(TaskManagementBloc, {
    dependencySelector: (state) => [state.tasks]
  });

  const completeLabsTask = getTask(TaskKey.COMPLETE_INITIAL_LAB_ORDER);
  const taskStatus = completeLabsTask?.status;

  const trackingData = {
    taskStatus: taskStatus ?? "unknown",
    ...labsTrackingData
  };

  useEffect(() => {
    void fetchLabStatus();
  }, [state.labData]);

  if (state.loading) {
    return (
      <LoadingContainer>
        <div>Loading lab status...</div>
      </LoadingContainer>
    );
  }

  if (state.error) {
    return (
      <ErrorContainer>
        <Translate msg={state.error} />
      </ErrorContainer>
    );
  }

  return (
    <>
      <Track event="Lab Status Overview Shown" data={trackingData} />

      {state.labData && (
        <CategoryContainer>
          {state.groupedCategories.map((category) => (
            <LabCategoryToggle key={category.category} category={category} />
          ))}
        </CategoryContainer>
      )}
    </>
  );
};

export default LabStatusOverview;
